import { injectGlobal, CSSObject } from '@emotion/css';

const htmlAndBodyBase: CSSObject = {
  backgroundColor: 'var(--color-white)',
  color: 'var(--color-body)',
  fontFamily: 'var(--font-body)',
  margin: 0,
  padding: 0,
};

injectGlobal({
  '*': {
    boxSizing: 'border-box',
  },
  html: {
    ...htmlAndBodyBase,
    scrollBehavior: 'auto',
  },
  body: { ...htmlAndBodyBase },
});
